import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useWhitelabel } from "../../contexts/WhitelabelContext";
import clicksims from "../../assets/img/clicksims.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Introduction = () => {
  const { t, i18n } = useTranslation();
  const { backgroundColor, fontColor, whitelabelUrl } = useWhitelabel();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  // Fallback to "ClickSims" if domainCompany is missing
  const brand = useMemo(
    () => activeUser?.domainCompany?.trim() || "ClickSims",
    [activeUser?.domainCompany]
  );

  const isRTL = i18n.language?.startsWith("ar");

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <Card className="shadow-lg border-0 rounded-4 text-center p-4">
            <Card.Body>
              <Image
                width={200}
                height={200}
                src={whitelabelUrl ?? clicksims}
                className="mb-4"
              />
              <h1 className="fw-bold mb-3">
                {t("documentation.introduction.welcomeTitle", { brand })}
              </h1>
              <p className="text-muted fs-5 mb-4">
                {t("documentation.introduction.welcomeText", { brand })}
              </p>
              <Button
                variant="primary"
                size="lg"
                className="rounded-pill"
                style={{
                  "--dynamic-bg-color": backgroundColor,
                  "--dynamic-font-color": fontColor,
                  border: "none",
                }}
                onClick={() => navigate("/docs/dashboard")}
              >
                {t("documentation.introduction.getStarted")}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Introduction;
